// c:\Users\julio\BotManager\frontend\src\pages\Admin\Admin.jsx
import { useState } from "react";
import TabNav from "../../components/TabNav/TabNav";
import AdminUsers from "./AdminUsers";
import AdminBots from "./AdminBots";
import AdminPayments from "./AdminPayments";
import AdminTopSellers from "./AdminTopSellers";
import AdminReports from "./AdminReports";
import AdminDomains from "./AdminDomains";
import "./Admin.css";

const TABS = [
  { id: "payments", label: "Pagamentos", icon: "fas fa-money-bill" },
  { id: "users", label: "Usuários", icon: "fas fa-users" },
  { id: "bots", label: "Bots", icon: "fas fa-robot" },
  { id: "reports", label: "Denúncias", icon: "fas fa-flag" },
  { id: "top_sellers", label: "Top Sellers", icon: "fas fa-trophy" },
  { id: "domains", label: "Domínios", icon: "fas fa-globe" },
];

export default function Admin() {
  const [activeTab, setActiveTab] = useState(TABS[0].id);

  return (
    <div className="page">
      <header className="dashboard-header">
        <h1 className="title">Painel Administrativo</h1>
        <p>Monitore a Spectrum</p>
      </header>

      <TabNav tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "users" && <AdminUsers />}
      {activeTab === "bots" && <AdminBots />}
      {activeTab === "reports" && <AdminReports />}
      {activeTab === "payments" && <AdminPayments />}
      {activeTab === "top_sellers" && <AdminTopSellers />}
      {activeTab === "domains" && <AdminDomains />}
    </div>
  );
}